import {useQuery} from 'react-query';
import {getAStoreAds} from '.';

const useGetAStoreAds = (
  params: IGetAStoreAdsPayload,
  onSuccess?: () => void,
) => {
  const {data, isLoading} = useQuery({
    queryKey: ['store-ads', params],
    queryFn: () => getAStoreAds(params),
    onSuccess: onSuccess,
    enabled: !!params.store_guid,
  });

  return {
    data: data?.results,
    count: data?.count,
    isLoading,
    onGetAStoreAds: onSuccess,
  };
};

export default useGetAStoreAds;
